import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const Sustainable = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/sustainable',
    element: <Sustainable />,
  },
];